// extracted by mini-css-extract-plugin
export default {"text":"arRCVM","positive":"brRCVM","negative":"crRCVM","neutral":"drRCVM"};